import { inject, Injectable } from '@angular/core';
import { IDLEvent } from './gtm.interface';
import { IS_NATIVE_APP } from '@pc/common';
import { FirebaseAnalyticsService } from '@pc/firebase-analytics';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const window: { dataLayer: any[] };

@Injectable({
  providedIn: 'root'
})
export class GtmService {
  private analytics = inject(FirebaseAnalyticsService);
  private sanitizer = inject(DomSanitizer);

  initGTM(gtmId: string): void {
    const safeGtmId: SafeHtml = this.sanitizer.sanitize(1, gtmId) || '';
    if (!safeGtmId) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    });

    const firstScript = document.getElementsByTagName('script')[0];
    const scriptElement = document.createElement('script');
    scriptElement.async = true;
    scriptElement.src = `https://www.googletagmanager.com/gtm.js?id=${safeGtmId}`;

    firstScript.parentNode?.insertBefore(scriptElement, firstScript);

    const body = document.body || document.getElementsByTagName('body')[0];
    const noscript = document.createElement('noscript');
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${safeGtmId}`;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    noscript.appendChild(iframe);
    body.insertBefore(noscript, body.firstChild);
  }

  sendEvent(obj: IDLEvent): void {
    if (IS_NATIVE_APP) {
      this.analytics.logFireBaseEvent(obj.event, obj);
    } else {
      const dataLayerEvent: Record<string, string> = {};
      Object.entries(obj).forEach(([key, value]) => {
        dataLayerEvent[key] = value;
      });
      window.dataLayer.push(dataLayerEvent);
    }
  }

  setUserProperty(agentNumber: string): void {
    this.analytics.setUserProperty(agentNumber);
  }
}
